import React, {useState} from "react";
import {ViewMangementContext} from "./InitialiseContext";


const PageView = (props) => {
    const [For, Set] = useState('LOADING') // this is used to set the page view .
    const [InvoiceType, setInvoiceType] = useState('') // this is used to set the invoice type (either it is Invoice 1 or 2)
    const [ModalContent, setModalContent] = useState({Title: '', Body: '', Class: ''}) // this is used to set the content of the default modal.
    const [AlertProperty, SETAlertProperty] = useState({Message: '', Type: '', Show: false, AutoHide: true}) // this is used to set the text message of the alert box.
    const CloseModal = () => { // this is used  to close or hide the default modal .
        const modal = document.getElementById('Modal');
        const body = document.getElementById('main_page_body');
        body.classList.remove("modal-open")
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('style', 'display: none');
        body.setAttribute('style', 'padding-right: none');
        const modalBackdrops = document.getElementsByClassName('modal-backdrop');
        document.body.removeChild(modalBackdrops[0]);
    }
    const setAlertProperty = (Hash) => { // used to set the alert messages on the page view .
        SETAlertProperty(Hash)
        if (Hash['AutoHide'] === true) {
            setTimeout(() => {
                SETAlertProperty({Message: '', Type: '', Show: false})
            }, 3000)
        }
    }
    return (
        <ViewMangementContext.Provider value={{For, Set, InvoiceType, setInvoiceType,
            ModalContent, setModalContent, AlertProperty, setAlertProperty, CloseModal}}>
            {props.children}
        </ViewMangementContext.Provider>
    )
}
export default PageView;